import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/lenis/dist/lenis-react.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/vercel/path0/src/components/scroll-top.tsx");
